export const MIN_COLUMNS = 1
export const MAX_COLUMNS = 35
export const MIN_ROWS = 1
export const MAX_ROWS = 35
export const COUNT_OPTIONS = Array.from(
  { length: Math.max(MAX_COLUMNS, MAX_ROWS) },
  (_, index) => index + 1
)
const POINTS_PER_PICA = 12
const POINTS_PER_INCH = 72

export const POINTS_PER_MM = POINTS_PER_INCH / 25.4
export const DEFAULT_GUTTER_POINTS = POINTS_PER_PICA
export const MIN_GUTTER_POINTS = 1
export const GUTTER_FIT_EPSILON = 0.0001
